import { useLocation } from 'react-router-dom';

import { NavLink } from '../nav-link/NavLink';

const TransferNavLink = () => {
  const location = useLocation();
  const isActive = location.pathname.startsWith('/transfers');

  return (
    <NavLink to="/transfers/new_transfer" data-active={isActive}>
      <NavLink.Icon name="Transfer" />
      <NavLink.Text>Transfers</NavLink.Text>
    </NavLink>
  );
};

export default TransferNavLink;
